import { render, staticRenderFns } from "./lightbox.vue?vue&type=template&id=2dc7a3e4&"
import script from "./lightbox.vue?vue&type=script&lang=js&"
export * from "./lightbox.vue?vue&type=script&lang=js&"
import style0 from "./lightbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports